


























import Vue from 'vue'
import { ItemWithCopyElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ItemWithCopyEl',
  data: () => ({
    showHint: false
  }),
  computed: {
    separatorStyle (): string {
      return 'border-color: ' + this.templateItemData.separator + ';'
    }
  },
  props: {
    templateItemData: {
      type: Object as () => ItemWithCopyElInterface,
      required: true
    }
  },
  methods: {
    copy (): void {
      this.showHint = true
      navigator.clipboard.writeText(
        this.templateItemData.value.trim()
      )
    }
  }
})
